import React from 'react';
import { FiGithub } from 'react-icons/fi';

export default function MinorCard({ list }) {
  const tags = (list.tech || '').split(',').map((t) => t.trim()).filter(Boolean);

  return (
    <article className="glass minor-card">
      <h3 className="minor-name">{list.name}</h3>

      {list.desc && <p className="minor-desc">{list.desc}</p>}

      {tags.length > 0 && (
        <div className="proj-tags">
          {tags.map((t) => (
            <span key={t} className="tag">
              {t}
            </span>
          ))}
        </div>
      )}

      <div className="proj-actions">
        <a
          className="proj-action"
          href={list.git}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FiGithub /> View source
        </a>
      </div>
    </article>
  );
}
